import { PermissionRow } from '@capturi/core'

export const getQAPermissions = ({
  enableQualityAssurance,
}: {
  enableQualityAssurance: boolean
}): PermissionRow[] => {
  const rows: PermissionRow[] = [
    {
      name: 'Scores',
      key: 'editScore',
      description: 'Permission to create, edit and delete scores.',
    },
    {
      name: 'Review Conversations',
      key: 'qualityAssurance',
      description:
        'Permission to review conversations and answer questionnaires.',
    },
    {
      name: 'Templates',
      key: 'editQuestionnaire',
      description: 'Permission to create, edit and delete questionnaires.',
      tooltip: 'Upgrade to get access to full quality assurance',
      disabled: !enableQualityAssurance,
    },
    // TODO: add back in when we have the QA Reports flag
    // {
    //   name: 'QA reports',
    //   key: 'viewReports',
    //   description: 'Permission to see aggregated QA results in QA reports',
    // },
  ]

  return rows
}
